import Vue from  'vue'
import VueI18n from "vue-i18n"
import messages from "../locale/message";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || 'es',
    fallbackLocale:'es',
    messages
});

export {
    i18n
}